<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div class="card-head box-shadow bg-white d-lg-flex align-items-center p-15 p-sm-20 p-md-25">
            <div class="d-sm-flex align-items-center" style="width:100%;">
                <Form style="width:100%;" class="search-box position-relative me-15">
                    <div class="row">
                        <div class="col-3">
                            <div class="form-group mb-15 mt-30 mb-sm-20 mb-md-25">
                                <Field name="recherche" type="text"  v-model="recherche"
                                class="form-control shadow-none text-black rounded-0 border-0" placeholder="Recherche"/>
                                <ErrorMessage name="recherche" class="text-danger"/>
                            </div>
                        </div>

                        <div v-if="!etatAgence" class="col-3">
                            <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                <label class="d-block text-black fw-semibold mb-10">
                                    Agence/Relais
                                </label>
                                <Field name="bureau" v-model="bureau" v-slot="{ field }">
                                    <Multiselect 
                                    :options="bureausBoitesOptions" 
                                    :searchable="true" 
                                    v-model="field.value"
                                    v-bind="field"
                                    placeholder="Sélectionner une agence/relais"
                                    no-options-text="Aucune agence selectionnée"
                                    no-results-text="Aucune agence selectionnée"
                                    />
                                </Field>
                                <ErrorMessage name="bureau" class="text-danger"/>
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                <label class="d-block text-black fw-semibold mb-10">
                                    Etat casier
                                </label>
                                <Field name="option" v-model="etat" v-slot="{ field }">
                                    <Multiselect 
                                    :options="etatsOptions" 
                                    :searchable="true" 
                                    v-model="field.value"
                                    v-bind="field"
                                    placeholder="Sélectionner un état"
                                    no-results-text="Aucun état trouvé"
                                    />
                                </Field>
                                <ErrorMessage name="option" class="text-danger"/>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="offset-10 col-3">
                            <div  class="form-group mb-15 mt-50 mb-sm-20 mb-md-25" >
                                <!-- <button
                                    class="default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0"
                                    type="button"
                                    >
                                    Exporter
                                    <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
                                </button> -->
                            </div>
                        </div>

                    </div>
                </Form>
            </div>
        </div>
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="table-responsive">
          <table class="table text-nowrap align-middle mb-0">
            <thead>
              <tr>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >Etagère
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  Code
                </th>
                
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >ETAT</th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >AGENCE</th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >NOMBRE DE COLIS</th>
              </tr>
            </thead>
            <tbody>
                <tr v-for="(cas , index) in casiers" :key="index">
                    <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                        {{cas.e_code}}
                    </td>
                    
                    <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                        {{ cas.c_code }}
                    </td>
                    <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                        {{ cas.c_estOccupe == 1 ? "Non vide" : "Vide" }}
                    </td>
                    <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                        {{ cas.agence_nom }}
                    </td>
                    <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                        {{ cas.NOMBRE }}
                    </td>
                   
                </tr>
            </tbody>
          </table>
        </div>
        <div
          class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center"
        >
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
        </div>
      </div>
    </div>
  </template>
  
  <script lang="ts">
    import { defineComponent, onMounted,watch, ref} from "vue";
    import { Form, Field, ErrorMessage, useForm } from 'vee-validate';
    import Swal from "sweetalert2";
    import axios from 'axios';
    import ApiService from "@/services/ApiService";
    import { suppression,error } from "@/utils/utils";
    import PaginationComponent from "@/components/Utilities/Pagination.vue"; //'@/components/Utilities/Pagination.vue';
    import Multiselect from '@vueform/multiselect';
    import JwtService from "@/services/JwtService";
  
export default({
  name: "EtatBoite",
  components: {
    Form,
    Field,
    ErrorMessage,
    PaginationComponent,
    Multiselect
    },
    setup(){
        const modelesBoitesOptions =ref();
        const bureausBoitesOptions =ref();
        const casiers = ref([]);
        const model = ref();
        const recherche = ref("");
        const etat = ref("");
        const bureau = ref();
        const etatsOptions =[
            { value: '', label: 'Selectionnez un état'},
            {
                label: "Non vide",
                value:"1"
            }, 
            { value: '0', label: 'Vide'}
        ];
        const searchTerm = ref('');
        const page = ref(1);
        const totalPages = ref(0);
        const limit = ref(10);
        const totalElements = ref(0);
        const action = async(page = 1, limi = 10, searchTerm = '')=>{
            const element = {
                model:model.value,
                recherche:recherche.value,
                etat:etat.value,
                bureau:bureau.value,
                page:page,
                totalPages:totalPages.value,
                limit:limit.value,
                totalElements:totalElements.value,
                mot:searchTerm
            }
            return await ApiService.post("/etats/nombre/colis/casier",element)
                .then((response) => {
                if (response.status === 200) {
                    casiers.value = response.data.data.data.raw;
                    console.log("LES DONNEEEESSS ===> ", casiers.value)
                    totalPages.value = response.data.data.totalPages;
                    limit.value = response.data.data.limit;
                    totalElements.value = response.data.data.totalElements;
                }
                })
                .catch((errorr) => {
                    error(errorr.response.data.message);
                });
            
        }
        const handlePaginate = ({ page_, limit_ }) => {
          try {
            page.value = page_;
            action(page_, limit_);
          } catch (error) {
            //
            
          }
        };
        const fetchBureaus = async () => {
            try {
            const response = await axios.get('/bureaus');
            const bureausData = response.data.data.data;
            bureausBoitesOptions.value = bureausData.map((bureau) => ({
                value: bureau.id,
                label: bureau.code+" [ "+ bureau.nom+" ]",
            }));
            } catch (error) {
              //
            }
        };
        const etatAgence = ref(true);
        if(JwtService.getUserCheckIfAllAgence() == "true"){
          etatAgence.value = false;
        }
        
    onMounted(() => {
        fetchBureaus();
        action(1, 10);
    });

    watch(bureau, (newValue, oldValue) => {
      if(newValue !== oldValue ){
        bureau.value = newValue;
       action(1, 10);
      }
    });

    watch(etat, (newValue, oldValue) => {
      if(newValue !== oldValue ){
        etat.value = newValue;
        action(1, 10);
      }
    });

    watch(recherche, (newValue, oldValue) => {
      if(newValue !== oldValue ){
        recherche.value = newValue;
        action(1, 10);
      }
    });
     
  
      return { suppression,bureau,etatAgence, page,totalPages,limit, totalElements,handlePaginate,casiers,bureausBoitesOptions,action,recherche,etat,model,etatsOptions,modelesBoitesOptions };
    },

  });
  </script>